const wrapperClass =
  "sm:flex-col sm:justify-center sm:w-1/2 sm:my-2 my-1 flex-auto sm:inline-block sm:p-3 p-1 rounded transition-all ";
const removeBtnClass =
  "absolute top-1 right-1 w-6 h-6 hover:text-rose-600 cursor-pointer";
export const IntegrationBookingInputComponent = (props) => {
  const { onChange, index } = props;

  return (
    <div className={wrapperClass}>
      <label className="mb-1">{props.label}</label>
      <br />
      <input
        key={index}
        className="form-input w-full"
        onChange={(e) => {
          onChange(e, index);
        }}
        value={props.value}
      />
    </div>
  );
};
